import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = {
  key: 0,
  class: "fw-bolder m-0"
}
const _hoisted_5 = {
  key: 0,
  class: "card-title m-0"
}
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = { class: "row mb-6" }
const _hoisted_9 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_10 = { class: "col-lg-8 fv-row" }
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_13 = { class: "col-lg-8 fv-row" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_16 = { class: "fv-plugins-message-container" }
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-envelope fs-3" }, null, -1)
const _hoisted_30 = { class: "fv-plugins-message-container" }
const _hoisted_31 = { class: "fv-help-block" }
const _hoisted_32 = { class: "row mb-6" }
const _hoisted_33 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_34 = { class: "col-lg-8 fv-row" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone fs-3" }, null, -1)
const _hoisted_36 = { class: "fv-plugins-message-container" }
const _hoisted_37 = { class: "fv-help-block" }
const _hoisted_38 = { class: "row mb-6" }
const _hoisted_39 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_40 = { class: "col-lg-8 fv-row" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_42 = { class: "pb-5" }
const _hoisted_43 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3" }, null, -1)
const _hoisted_48 = { class: "fv-plugins-message-container" }
const _hoisted_49 = { class: "fv-help-block" }
const _hoisted_50 = { class: "row mb-6" }
const _hoisted_51 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_52 = { class: "col-lg-8 fv-row" }
const _hoisted_53 = { class: "fv-plugins-message-container" }
const _hoisted_54 = { class: "fv-help-block" }
const _hoisted_55 = { class: "row mb-6" }
const _hoisted_56 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_57 = { class: "col-lg-8 fv-row" }
const _hoisted_58 = { class: "row mb-6" }
const _hoisted_59 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_60 = { class: "col-lg-8 fv-row" }
const _hoisted_61 = { class: "fv-plugins-message-container" }
const _hoisted_62 = { class: "fv-help-block" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed my-5" }, null, -1)
const _hoisted_64 = { class: "pb-5" }
const _hoisted_65 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_66 = { class: "row mb-6" }
const _hoisted_67 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_68 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_69 = { class: "fv-plugins-message-container" }
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "row mb-6" }
const _hoisted_72 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_73 = { class: "col-lg-8 fv-row" }
const _hoisted_74 = { class: "fv-plugins-message-container" }
const _hoisted_75 = { class: "fv-help-block" }
const _hoisted_76 = { class: "row mb-6" }
const _hoisted_77 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_78 = { class: "col-lg-8 fv-row" }
const _hoisted_79 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_80 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_81 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_82 = { class: "card mb-5 mb-xl-10" }
const _hoisted_83 = { class: "card-header border-0" }
const _hoisted_84 = { class: "card-title m-0" }
const _hoisted_85 = { class: "fw-bolder m-0" }
const _hoisted_86 = { class: "collapse show" }
const _hoisted_87 = { class: "card-body border-top p-9" }
const _hoisted_88 = { class: "row mb-6" }
const _hoisted_89 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_90 = { class: "col-lg-8 fv-row" }
const _hoisted_91 = { class: "row mb-6" }
const _hoisted_92 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_93 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_94 = { class: "row mb-6" }
const _hoisted_95 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_96 = { class: "col-lg-8 fv-row" }
const _hoisted_97 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_98 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_99 = { class: "col-lg-8 fv-row" }
const _hoisted_100 = { class: "row mb-6" }
const _hoisted_101 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_102 = { class: "col-lg-8 fv-row" }
const _hoisted_103 = {
  key: 1,
  class: "row mb-6"
}
const _hoisted_104 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_105 = { class: "col-lg-8 fv-row" }
const _hoisted_106 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_107 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_108 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_109 = { class: "col-lg-4 fv-row fv-plugins-icon-container" }
const _hoisted_110 = {
  key: 2,
  class: "row mb-6"
}
const _hoisted_111 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_112 = { class: "col-lg-8 fv-row" }
const _hoisted_113 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_114 = ["download", "href"]
const _hoisted_115 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_116 = { class: "row mb-6" }
const _hoisted_117 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_118 = { class: "col-lg-8 fv-row" }
const _hoisted_119 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_120 = ["download", "href"]
const _hoisted_121 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_122 = {
  key: 3,
  class: "row mb-6"
}
const _hoisted_123 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_124 = { class: "col-lg-8 fv-row" }
const _hoisted_125 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_126 = ["download", "href"]
const _hoisted_127 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_128 = { class: "card mb-5 mb-xl-10" }
const _hoisted_129 = { class: "card-header border-0" }
const _hoisted_130 = { class: "card-title m-0" }
const _hoisted_131 = { class: "fw-bolder m-0" }
const _hoisted_132 = { class: "collapse show" }
const _hoisted_133 = { class: "card-body border-top p-9" }
const _hoisted_134 = { class: "row mb-6" }
const _hoisted_135 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_136 = { class: "col-lg-8 fv-row" }
const _hoisted_137 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_138 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_139 = { class: "col-lg-6 fv-row fv-plugins-icon-container" }
const _hoisted_140 = { class: "row" }
const _hoisted_141 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_142 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_143 = { class: "row" }
const _hoisted_144 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_145 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_146 = { class: "row" }
const _hoisted_147 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_148 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_149 = { class: "row" }
const _hoisted_150 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_151 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_152 = { class: "row" }
const _hoisted_153 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_154 = { class: "col-lg-8 fv-row col-form-label" }
const _hoisted_155 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_156 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_157 = { class: "col-lg-8 fv-row" }
const _hoisted_158 = { class: "card mb-5 mb-xl-10" }
const _hoisted_159 = { class: "card-header border-0" }
const _hoisted_160 = { class: "card-title m-0" }
const _hoisted_161 = { class: "fw-bolder m-0" }
const _hoisted_162 = { class: "collapse show" }
const _hoisted_163 = { class: "card-body border-top p-9" }
const _hoisted_164 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_165 = { class: "row mb-6" }
const _hoisted_166 = { class: "col-lg-12 fv-row" }
const _hoisted_167 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_168 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_169 = { class: "col-lg-8 fv-row" }
const _hoisted_170 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_171 = ["download", "href"]
const _hoisted_172 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"var(--el-text-color-secondary)","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "50",
    height: "50",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1)
const _hoisted_173 = { class: "row mb-6" }
const _hoisted_174 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_175 = { class: "col-lg-8 fv-row" }
const _hoisted_176 = {
  class: "dropzone",
  id: "kt_dropzonejs_otros_documentos"
}
const _hoisted_177 = { class: "dz-message needsclick" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-file-earmark-arrow-up text-primary fs-3x" }, null, -1)
const _hoisted_179 = { class: "ms-4" }
const _hoisted_180 = { class: "fs-5 fw-bolder text-gray-900 mb-1" }
const _hoisted_181 = { class: "fs-7 fw-bold text-gray-400" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_Page = _resolveComponent("Page")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Page, { showBack: "" }, {
    actions: _withCtx(() => [
      (
          _ctx.profesional?.estado === _ctx.FormularioEstado.pendiente ||
          _ctx.profesional?.estado === _ctx.FormularioEstado.realizadoPorError ||
          _ctx.profesional?.estado === _ctx.FormularioEstado.noApto
        )
        ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { onClick: _ctx.aprobar }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.aprobar.button")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  (
                _ctx.profesional?.estado === _ctx.FormularioEstado.noApto ||
                _ctx.profesional?.estado === _ctx.FormularioEstado.realizadoPorError
              )
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 0,
                        onClick: _ctx.pendiente
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.pendiente.button")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
                _ctx.profesional?.estado === _ctx.FormularioEstado.pendiente ||
                _ctx.profesional?.estado === _ctx.FormularioEstado.realizadoPorError
              )
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 1,
                        onClick: _ctx.noApto
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.descartar.button")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
                _ctx.profesional?.estado === _ctx.FormularioEstado.pendiente ||
                _ctx.profesional?.estado === _ctx.FormularioEstado.noApto
              )
                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                        key: 2,
                        onClick: _ctx.realizadoPorError
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.realizadoPorError.button")), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: 
            _ctx.isLoadingAprobar ||
            _ctx.isLoadingNoApto ||
            _ctx.isLoadingPendiente ||
            _ctx.isLoadingRealizadoPorError
          ,
                disabled: 
            _ctx.isLoadingAprobar ||
            _ctx.isLoadingNoApto ||
            _ctx.isLoadingPendiente ||
            _ctx.isLoadingRealizadoPorError
          
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("formularios.profesionalDetalle.cambiarEstado.button")) + " ", 1),
                  _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_arrow_down)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_el_tabs, { type: "border-card" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.listadoGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.profesional)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.datosSolicitanteGroup", {
                    codigo: _ctx.profesional.codigo,
                  })), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.estado)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("span", {
                          class: _normalizeClass(_ctx.claseEstado)
                        }, _toDisplayString(_ctx.estado), 3)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("formularios.familiaDetalle.tratamiento.label")), 1),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "tratamiento",
                          placeholder: " ",
                          modelValue: _ctx.tratamiento.text,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tratamiento.text) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.nombre.label")), 1),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createVNode(_component_el_input, {
                              disabled: "",
                              type: "text",
                              name: "nombre",
                              placeholder: " ",
                              modelValue: _ctx.datosSolicitud.nombre,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.datosSolicitud.nombre) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", _hoisted_17, [
                                _createVNode(_component_ErrorMessage, { name: "nombre" })
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createVNode(_component_el_input, {
                              disabled: "",
                              type: "text",
                              name: "apellidos",
                              placeholder: " ",
                              modelValue: _ctx.datosSolicitud.apellidos,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.datosSolicitud.apellidos) = $event))
                            }, null, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("div", _hoisted_20, [
                                _createVNode(_component_ErrorMessage, { name: "apellidos" })
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.dni.label")), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "dni",
                          placeholder: " ",
                          modelValue: _ctx.datosSolicitud.dni,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.datosSolicitud.dni) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_ErrorMessage, { name: "dni" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.email.label")), 1),
                      _createElementVNode("div", _hoisted_28, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "email",
                          placeholder: " ",
                          modelValue: _ctx.datosSolicitud.email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.datosSolicitud.email) = $event))
                        }, {
                          append: _withCtx(() => [
                            _hoisted_29
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            _createVNode(_component_ErrorMessage, { name: "email" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("label", _hoisted_33, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.telefono.label")), 1),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "telefono",
                          placeholder: " ",
                          modelValue: _ctx.datosSolicitud.telefono,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.datosSolicitud.telefono) = $event))
                        }, {
                          append: _withCtx(() => [
                            _hoisted_35
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_ErrorMessage, { name: "telefono" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.fechaNacimiento.label")), 1),
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_el_date_picker, {
                          disabled: "",
                          format: "DD/MM/YYYY",
                          modelValue: _ctx.datosSolicitud.fechaNacimiento,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.datosSolicitud.fechaNacimiento) = $event)),
                          type: "date",
                          class: "w-100"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _hoisted_41,
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("h4", _hoisted_43, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.direccionGroup")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.direccion.label")), 1),
                      _createElementVNode("div", _hoisted_46, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "direccion",
                          placeholder: " ",
                          modelValue: _ctx.datosSolicitud.direccion,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.datosSolicitud.direccion) = $event))
                        }, {
                          append: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_ErrorMessage, { name: "direccion" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.localidad.label")), 1),
                      _createElementVNode("div", _hoisted_52, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "localidad",
                          placeholder: " ",
                          modelValue: _ctx.datosSolicitud.localidad,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.datosSolicitud.localidad) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createVNode(_component_ErrorMessage, { name: "localidad" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t("formularios.familiaDetalle.comarca.label")), 1),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_el_select, {
                          disabled: !_ctx.isAdmin,
                          modelValue: _ctx.profesionalComarcaId,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.profesionalComarcaId) = $event)),
                          onChange: _ctx.changeComarca,
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["disabled", "modelValue", "onChange"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("label", _hoisted_59, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.provincia.label")), 1),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          type: "text",
                          name: "provincia",
                          placeholder: " ",
                          modelValue: _ctx.datosSolicitud.provincia,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.datosSolicitud.provincia) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("div", _hoisted_62, [
                            _createVNode(_component_ErrorMessage, { name: "provincia" })
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_63,
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("h4", _hoisted_65, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.otrosDatos")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_66, [
                      _createElementVNode("label", _hoisted_67, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.carnetConducir.label")), 1),
                      _createElementVNode("div", _hoisted_68, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.carnetConducir,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.datosSolicitud.carnetConducir) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_ErrorMessage, { name: "carnetConducir" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("label", _hoisted_72, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.vehiculoPropio.label")), 1),
                      _createElementVNode("div", _hoisted_73, [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.datosSolicitud.vehiculoPropio,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.datosSolicitud.vehiculoPropio) = $event)),
                          class: "w-100",
                          disabled: "",
                          placeholder: " "
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vehiculos, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.nombre,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("div", _hoisted_75, [
                            _createVNode(_component_ErrorMessage, { name: "vehiculoPropio" })
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("label", _hoisted_77, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.idiomas.label")), 1),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("ul", _hoisted_79, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosSolicitud.idiomas, (idioma, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "row"
                            }, [
                              _createElementVNode("div", _hoisted_80, [
                                _createVNode(_component_el_select, {
                                  disabled: "",
                                  modelValue: idioma.nombreIdioma,
                                  "onUpdate:modelValue": ($event: any) => ((idioma.nombreIdioma) = $event),
                                  class: "w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nombreIdioma, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_81, [
                                _createVNode(_component_el_select, {
                                  disabled: "",
                                  modelValue: idioma.nivel,
                                  "onUpdate:modelValue": ($event: any) => ((idioma.nivel) = $event),
                                  class: "w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nivel, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.datosProfesionalGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("h3", _hoisted_85, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.datosProfesionalGroup")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_86, [
                  _createElementVNode("div", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, [
                      _createElementVNode("label", _hoisted_89, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.comarcasTrabajo.label")), 1),
                      _createElementVNode("div", _hoisted_90, [
                        _createVNode(_component_el_select, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.comarcasTrabajo,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.datosSolicitud.comarcasTrabajo) = $event)),
                          multiple: "",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comarcas, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_91, [
                      _createElementVNode("label", _hoisted_92, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.disponeTitulacion.label")), 1),
                      _createElementVNode("div", _hoisted_93, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.disponeTitulacion,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.datosSolicitud.disponeTitulacion) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("label", _hoisted_95, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacion.label")), 1),
                      _createElementVNode("div", _hoisted_96, [
                        _createVNode(_component_el_select, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.titulacion,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.datosSolicitud.titulacion) = $event)),
                          multiple: "",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosSolicitud.disponeTitulacion
                        ? _ctx.titulaciones
                        : _ctx.sinTitulaciones, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.id,
                                label: item.text,
                                value: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    (_ctx.datosSolicitud.titulacionOtras)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                          _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacionOtras.label")), 1),
                          _createElementVNode("div", _hoisted_99, [
                            _createVNode(_component_el_input, {
                              disabled: "",
                              type: "text",
                              name: "titulacionOtras",
                              placeholder: " ",
                              modelValue: _ctx.datosSolicitud.titulacionOtras,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.datosSolicitud.titulacionOtras) = $event))
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_100, [
                      _createElementVNode("label", _hoisted_101, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.experienciaCuidadoMenores.label"
                    )), 1),
                      _createElementVNode("div", _hoisted_102, [
                        _createVNode(_component_el_select, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.experienciaCuidadoMenores,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.datosSolicitud.experienciaCuidadoMenores) = $event)),
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "EXPERIENCIAPROFESIONAL",
                              label: 
                        _ctx.$t('experienciaCuidadoMenores.EXPERIENCIAPROFESIONAL')
                      
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              value: "EXPERIENCIANOPROFESIONAL",
                              label: 
                        _ctx.$t('experienciaCuidadoMenores.EXPERIENCIANOPROFESIONAL')
                      
                            }, null, 8, ["label"]),
                            _createVNode(_component_el_option, {
                              value: "SINEXPERIENCIA",
                              label: _ctx.$t('experienciaCuidadoMenores.SINEXPERIENCIA')
                            }, null, 8, ["label"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    (_ctx.datosSolicitud.experiencia?.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                          _createElementVNode("label", _hoisted_104, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.experiencia.label")), 1),
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("ul", _hoisted_106, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosSolicitud.experiencia, (ele, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  class: "row"
                                }, [
                                  _createElementVNode("div", _hoisted_107, [
                                    _createVNode(_component_el_input, {
                                      disabled: "",
                                      type: "text",
                                      placeholder: " ",
                                      modelValue: ele.tipo,
                                      "onUpdate:modelValue": ($event: any) => ((ele.tipo) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_108, [
                                    _createVNode(_component_el_input, {
                                      disabled: "",
                                      type: "text",
                                      placeholder: " ",
                                      modelValue: ele.dirigidoA,
                                      "onUpdate:modelValue": ($event: any) => ((ele.dirigidoA) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _createElementVNode("div", _hoisted_109, [
                                    _createVNode(_component_el_input, {
                                      disabled: "",
                                      type: "text",
                                      placeholder: " ",
                                      modelValue: ele.duracion,
                                      "onUpdate:modelValue": ($event: any) => ((ele.duracion) = $event)
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.titulacionAdjunta.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_110, [
                          _createElementVNode("label", _hoisted_111, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.titulacionAdjunta.label")), 1),
                          _createElementVNode("div", _hoisted_112, [
                            _createElementVNode("ul", _hoisted_113, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titulacionAdjunta, (file, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  class: "el-upload-list__item is-success",
                                  tabindex: "0"
                                }, [
                                  _createElementVNode("a", {
                                    class: "el-upload-list__item-name",
                                    download: file.nombre,
                                    href: file.data
                                  }, [
                                    _createVNode(_component_el_image, {
                                      class: "align-middle",
                                      style: {"width":"100px","height":"100px"},
                                      src: file.data,
                                      fit: "cover"
                                    }, {
                                      error: _withCtx(() => [
                                        _hoisted_115
                                      ]),
                                      _: 2
                                    }, 1032, ["src"]),
                                    _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                  ], 8, _hoisted_114)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_116, [
                      _createElementVNode("label", _hoisted_117, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.certificadoAntecedentes.label"
                    )), 1),
                      _createElementVNode("div", _hoisted_118, [
                        _createElementVNode("ul", _hoisted_119, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.certificadoAntecedentes, (file, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "el-upload-list__item is-success",
                              tabindex: "0"
                            }, [
                              _createElementVNode("a", {
                                class: "el-upload-list__item-name",
                                download: file.nombre,
                                href: file.data
                              }, [
                                _createVNode(_component_el_image, {
                                  class: "align-middle",
                                  style: {"width":"100px","height":"100px"},
                                  src: file.data,
                                  fit: "cover"
                                }, {
                                  error: _withCtx(() => [
                                    _hoisted_121
                                  ]),
                                  _: 2
                                }, 1032, ["src"]),
                                _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                              ], 8, _hoisted_120)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    (_ctx.otrosDocumentosVisor.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                          _createElementVNode("label", _hoisted_123, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.otrosDocumentos.label")), 1),
                          _createElementVNode("div", _hoisted_124, [
                            _createElementVNode("ul", _hoisted_125, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otrosDocumentosVisor, (file, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  class: "el-upload-list__item is-success",
                                  tabindex: "0"
                                }, [
                                  _createElementVNode("a", {
                                    class: "el-upload-list__item-name",
                                    download: file.nombre,
                                    href: file.data
                                  }, [
                                    _createVNode(_component_el_image, {
                                      class: "align-middle",
                                      style: {"width":"100px","height":"100px"},
                                      src: file.data,
                                      fit: "cover"
                                    }, {
                                      error: _withCtx(() => [
                                        _hoisted_127
                                      ]),
                                      _: 2
                                    }, 1032, ["src"]),
                                    _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                  ], 8, _hoisted_126)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.disponibilidadGroup')
          }, {
            default: _withCtx(() => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_128, [
                _createElementVNode("div", _hoisted_129, [
                  _createElementVNode("div", _hoisted_130, [
                    _createElementVNode("h3", _hoisted_131, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.disponibilidadGroup")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_132, [
                  _createElementVNode("div", _hoisted_133, [
                    _createElementVNode("div", _hoisted_134, [
                      _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.$t("formularios.familiaDetalle.menor.diasHoras.label")), 1),
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("ul", _hoisted_137, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datosSolicitud.disponibilidad, (tiempo, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              class: "row"
                            }, [
                              _createElementVNode("div", _hoisted_138, [
                                _createVNode(_component_el_select, {
                                  disabled: "",
                                  modelValue: tiempo.dias,
                                  "onUpdate:modelValue": ($event: any) => ((tiempo.dias) = $event),
                                  multiple: "",
                                  class: "w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dias, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _createElementVNode("div", _hoisted_139, [
                                _createVNode(_component_el_select, {
                                  disabled: "",
                                  modelValue: tiempo.horas,
                                  "onUpdate:modelValue": ($event: any) => ((tiempo.horas) = $event),
                                  multiple: "",
                                  class: "w-100"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.horarios, (item) => {
                                      return (_openBlock(), _createBlock(_component_el_option, {
                                        key: item.id,
                                        label: item.text,
                                        value: item.id
                                      }, null, 8, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_140, [
                      _createElementVNode("label", _hoisted_141, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.laborables.label")), 1),
                      _createElementVNode("div", _hoisted_142, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.laborables,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.datosSolicitud.laborables) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_143, [
                      _createElementVNode("label", _hoisted_144, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.finesDeSemana.label")), 1),
                      _createElementVNode("div", _hoisted_145, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.finesDeSemana,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.datosSolicitud.finesDeSemana) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_146, [
                      _createElementVNode("label", _hoisted_147, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.festivos.label")), 1),
                      _createElementVNode("div", _hoisted_148, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.festivos,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.datosSolicitud.festivos) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_149, [
                      _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.urgencias.label")), 1),
                      _createElementVNode("div", _hoisted_151, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.urgencias,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.datosSolicitud.urgencias) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _createElementVNode("label", _hoisted_153, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.noches.label")), 1),
                      _createElementVNode("div", _hoisted_154, [
                        _createVNode(_component_el_switch, {
                          disabled: "",
                          modelValue: _ctx.datosSolicitud.noches,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.datosSolicitud.noches) = $event))
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    (_ctx.datosSolicitud.detalleDisponibilidad)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_155, [
                          _createElementVNode("label", _hoisted_156, _toDisplayString(_ctx.$t(
                      "formularios.profesionalDetalle.detalleDisponibilidad.label"
                    )), 1),
                          _createElementVNode("div", _hoisted_157, [
                            _createVNode(_component_el_input, {
                              disabled: "",
                              modelValue: _ctx.datosSolicitud.detalleDisponibilidad,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.datosSolicitud.detalleDisponibilidad) = $event)),
                              rows: 3,
                              autosize: { minRows: 2 },
                              type: "textarea",
                              placeholder: " "
                            }, null, 8, ["modelValue"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])), [
                [_directive_loading, _ctx.cargaDetalle]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_tab_pane, {
            label: _ctx.$t('formularios.profesionalDetalle.notasYAdjuntos')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_158, [
                _createElementVNode("div", _hoisted_159, [
                  _createElementVNode("div", _hoisted_160, [
                    _createElementVNode("h3", _hoisted_161, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.notasYAdjuntos")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("div", _hoisted_163, [
                    _createElementVNode("label", _hoisted_164, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.notas")), 1),
                    _createElementVNode("div", _hoisted_165, [
                      _createElementVNode("div", _hoisted_166, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.notas,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.notas) = $event)),
                          autosize: { minRows: 5 },
                          type: "textarea",
                          placeholder: " "
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    (_ctx.otrosDocumentosVisor.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                          _createElementVNode("label", _hoisted_168, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.otrosDocumentos.label")), 1),
                          _createElementVNode("div", _hoisted_169, [
                            _createElementVNode("ul", _hoisted_170, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otrosDocumentosVisor, (file, i) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  key: i,
                                  class: "el-upload-list__item is-success",
                                  tabindex: "0"
                                }, [
                                  _createElementVNode("a", {
                                    class: "el-upload-list__item-name",
                                    download: file.nombre,
                                    href: file.data
                                  }, [
                                    _createVNode(_component_el_image, {
                                      class: "align-middle",
                                      style: {"width":"100px","height":"100px"},
                                      src: file.data,
                                      fit: "cover"
                                    }, {
                                      error: _withCtx(() => [
                                        _hoisted_172
                                      ]),
                                      _: 2
                                    }, 1032, ["src"]),
                                    _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                  ], 8, _hoisted_171)
                                ]))
                              }), 128))
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_173, [
                      _createElementVNode("label", _hoisted_174, _toDisplayString(_ctx.$t("formularios.profesionalDetalle.nuevosDocumentos.label")), 1),
                      _createElementVNode("div", _hoisted_175, [
                        _createElementVNode("div", _hoisted_176, [
                          _createElementVNode("div", _hoisted_177, [
                            _hoisted_178,
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("h3", _hoisted_180, _toDisplayString(_ctx.$t(
                              "formularios.profesionalDetalle.nuevosDocumentos.accion"
                            )), 1),
                              _createElementVNode("span", _hoisted_181, _toDisplayString(_ctx.$t(
                            "formularios.profesionalDetalle.nuevosDocumentos.descripcion"
                          )), 1)
                            ])
                          ])
                        ]),
                        _createVNode(_component_ErrorMessage, {
                          name: "otrosDocumentos",
                          class: "fv-plugins-message-container invalid-feedback"
                        })
                      ])
                    ]),
                    _createVNode(_component_el_button, {
                      class: "float-end",
                      type: "primary",
                      onClick: _ctx.onSubmit,
                      loading: _ctx.formLoading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t(
                    "formularios.profesionalDetalle.guardarNotasYAdjuntos.button"
                  )), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ])
                ])
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}